/* Hatoon product cards: device-local favourites (heart buttons) */
(function () {
  var KEY = 'htn_favs';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function paint(root) {
    var favs = read();
    (root || document).querySelectorAll('[data-htn-fav]').forEach(function (b) {
      var v = favs.indexOf(b.getAttribute('data-htn-fav')) > -1 ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== v) b.setAttribute('aria-pressed', v);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-htn-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-htn-fav'), favs = read(), i = favs.indexOf(h);
    if (i > -1) favs.splice(i, 1); else favs.push(h);
    write(favs); paint();
  });
  function init() {
    paint();
    if (window.MutationObserver) {
      var queued = false;
      new MutationObserver(function (m) {
        if (queued) return;
        for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { queued = true; requestAnimationFrame(function () { queued = false; paint(); }); break; }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Recently viewed: undo Shopify server-side square crop so images show whole */
(function () {
  function fix(u) {
    return u.replace(/([?&])crop=[a-z]+&?/, '$1').replace(/([?&])height=\d+&?/g, '$1').replace(/([?&]width=)\d+/, '$1600').replace(/[?&]$/, '');
  }
  function run() {
    var imgs = document.querySelectorAll('.recently-viewed-products img:not([data-htn-uncrop])');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      im.setAttribute('data-htn-uncrop', '1');
      var s = im.getAttribute('src'), ss = im.getAttribute('srcset');
      if (ss) im.setAttribute('srcset', ss.split(',').map(function (p) { p = p.trim().split(' '); p[0] = fix(p[0]); return p.join(' '); }).join(', '));
      if (s) im.setAttribute('src', fix(s));
      im.removeAttribute('height');
    }
  }
  function init() {
    run();
    var q = false;
    if (window.MutationObserver) new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; run(); }); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* WHY HATOON? headline: first sentence (up to ? / ؟) becomes a small eyebrow, the rest is the title */
(function () {
  function run() {
    var hs = document.querySelectorAll('[id$="section_slideshow_KPkjer"] .heading h3:not([data-htn-eb])');
    for (var i = 0; i < hs.length; i++) {
      var h = hs[i], t = h.textContent.replace(/\s+/g, ' ').trim();
      h.setAttribute('data-htn-eb', '1');
      var m = t.match(/^(.{2,40}?[?؟])\s*(.+)$/);
      if (!m) continue;
      h.innerHTML = '';
      var e = document.createElement('span'); e.className = 'htn-eyebrow'; e.textContent = m[1];
      var s = document.createElement('strong'); s.textContent = m[2];
      h.appendChild(e); h.appendChild(s);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* ---- Mobile drawer: brand header, search, promo card ---- */
(function () {
  function build() {
    var nav = document.getElementById('nav');
    if (!nav || nav.querySelector('.htn-brand')) return;
    var ar = /^ar/i.test(document.documentElement.lang || '');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var head = nav.querySelector('.header');
    if (!head) return;
    var logo = document.createElement('a');
    logo.className = 'htn-brand'; logo.href = root;
    logo.innerHTML = '<img src="//hatoon.shop/cdn/shop/files/Logo_HATOON_Black.svg?width=120" alt="Hatoon" width="46" height="46">' +
      '<span class="htn-brand-t"><b>' + (ar ? 'هاتون' : 'Hatoon') + '</b><small>' + (ar ? 'خير طبيعي لحياة أفضل' : 'Natural goodness for a better life') + '</small></span>';
    head.insertBefore(logo, head.firstChild);
    var f = document.createElement('form');
    f.className = 'htn-search'; f.action = root + 'search'; f.method = 'get'; f.setAttribute('role', 'search');
    f.innerHTML = '<input type="search" name="q" placeholder="' + (ar ? 'ابحث عن منتج ..' : 'Search products ..') + '" aria-label="' + (ar ? 'بحث' : 'Search') + '"><button type="submit" aria-label="' + (ar ? 'بحث' : 'Search') + '"></button>';
    head.parentNode.insertBefore(f, head.nextSibling);
    var list = nav.querySelector('ul.category-img');
    var p = document.createElement('div');
    p.className = 'htn-promo';
    p.innerHTML = '<div class="htn-promo-t"><b>' + (ar ? 'باقات هاتون' : 'Hatoon Bundles') + '</b><span>' + (ar ? 'وفّر أكتر + هدية مجانية + شحن مجاني' : 'Save more + FREE gift + FREE shipping') + '</span>' +
      '<a href="' + root + 'collections/bundles">' + (ar ? 'تسوق الباقات' : 'Shop Bundles') + '</a></div>' +
      '<img src="//hatoon.shop/cdn/shop/files/04.png?width=360" alt="" loading="lazy">';
    if (list) list.parentNode.insertBefore(p, list.nextSibling);
  }
  build();
  document.addEventListener('DOMContentLoaded', build);
  window.addEventListener('load', function () { build(); setTimeout(build, 600); setTimeout(build, 2000); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[aria-controls="nav"]')) { build(); setTimeout(build, 50); } }, true);
  /* theme JS may rebuild #nav after load -> re-insert if our pieces disappear */
  try {
    var mo = new MutationObserver(function () { var n = document.getElementById('nav'); if (n && !n.querySelector('.htn-brand')) build(); });
    var start = function () { var n = document.getElementById('nav-outer') || document.body; mo.observe(n, { childList: true, subtree: true }); };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  } catch (e) {}
})();

/* ---- load part 2 of the stylesheet (kept separate: Shopify truncates one big asset) ---- */
(function () {
  if (document.getElementById('htn-extra-css')) return;
  var link = document.getElementById('htn-product-cards-css');
  if (!link || !link.href) return;
  var l = document.createElement('link');
  l.rel = 'stylesheet'; l.id = 'htn-extra-css';
  l.href = link.href.replace('htn-product-cards.css', 'htn-extra.css').replace(/\?.*$/, '') + '?v=20260927h';
  document.head.appendChild(l);
})();

/* ---- lock page scroll while the mobile menu is open ---- */
(function () {
  function tick() {
    var o = document.getElementById('nav-outer');
    var cs = o && getComputedStyle(o);
    var open = !!o && window.innerWidth <= 1024 && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.5;
    document.documentElement.classList.toggle('htn-nav-open', open);
  }
  document.addEventListener('click', function () { setTimeout(tick, 30); setTimeout(tick, 400); }, true);
  window.addEventListener('resize', tick, { passive: true });
  window.addEventListener('popstate', tick);
  document.addEventListener('keyup', function (e) { if (e.key === 'Escape') setTimeout(tick, 30); });
})();

/* ---- instant feedback on "add to cart" (Shopify's add request itself takes ~0.7-1.5s) ---- */
(function () {
  var ar = /^ar/i.test(document.documentElement.lang || '');
  var T = { adding: ar ? 'جاري الإضافة…' : 'Adding…', added: ar ? 'تمت الإضافة ✓' : 'Added ✓' };
  function bump() {
    var els = document.querySelectorAll('.cart-count');
    Array.prototype.forEach.call(els, function (el) {
      var n = parseInt((el.textContent || '0').replace(/\D/g, ''), 10) || 0;
      if (el.getAttribute('data-htn-prev') === null) el.setAttribute('data-htn-prev', String(n));
      el.textContent = String(n + 1);
      el.classList.remove('hidden');
    });
  }
  function settle(btn, label, orig) {
    var t0 = Date.now();
    (function wait() {
      var busy = btn.classList.contains('processing') || Date.now() - t0 < 120;
      if (busy && Date.now() - t0 < 12000) return setTimeout(wait, 100);
      btn.classList.remove('htn-adding');
      if (label) label.textContent = T.added;
      btn.classList.add('htn-added');
      setTimeout(function () {
        btn.classList.remove('htn-added');
        if (label) label.textContent = orig;
      }, 1100);
    })();
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var btn = f.querySelector('button[type="submit"]');
    if (!btn || btn.classList.contains('htn-adding')) return;
    var label = btn.querySelector('span');
    var orig = label ? label.textContent : '';
    btn.classList.add('htn-adding');
    if (label) label.textContent = T.adding;
    bump();
    settle(btn, label, orig);
  }, true);
})();

/* ---- Add to cart: product flies to the cart + cart shakes; side cart no longer pops open ---- */
(function () {
  if (window.__htnFlyCart) return; window.__htnFlyCart = 1;
  var ar = /^ar/i.test(document.documentElement.lang || '');
  var T = { added: ar ? 'تمت الإضافة إلى السلة' : 'Added to cart', view: ar ? 'عرض السلة' : 'View cart' };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* styles */
  var css = document.createElement('style');
  css.textContent =
    '.htn-fly-img{position:fixed;z-index:2147483000;pointer-events:none;border-radius:16px;object-fit:contain;background:#fff;box-shadow:0 14px 34px rgba(31,32,22,.25);will-change:transform,opacity}' +
    '@keyframes htnCartShake{0%{transform:rotate(0) scale(1)}15%{transform:rotate(-14deg) scale(1.12)}30%{transform:rotate(12deg) scale(1.12)}45%{transform:rotate(-9deg) scale(1.08)}60%{transform:rotate(6deg) scale(1.04)}75%{transform:rotate(-3deg)}100%{transform:rotate(0) scale(1)}}' +
    '.htn-cart-shake{animation:htnCartShake .7s cubic-bezier(.36,.07,.19,.97) both;transform-origin:50% 60%}' +
    '@keyframes htnBadgePop{0%{transform:scale(1)}40%{transform:scale(1.55)}100%{transform:scale(1)}}' +
    '.htn-badge-pop{animation:htnBadgePop .5s ease both}' +
    '.htn-cart-toast{position:fixed;z-index:2147482000;left:50%;bottom:24px;transform:translate(-50%,20px);opacity:0;display:flex;align-items:center;gap:14px;padding:12px 12px 12px 18px;border-radius:999px;background:#1f2016;color:#fff;font-size:14px;font-weight:600;box-shadow:0 14px 34px rgba(0,0,0,.25);transition:opacity .3s ease,transform .3s ease;max-width:calc(100vw - 32px);white-space:nowrap}' +
    '[dir="rtl"] .htn-cart-toast{padding:12px 18px 12px 12px}' +
    '.htn-cart-toast.is-on{opacity:1;transform:translate(-50%,0)}' +
    '.htn-cart-toast svg{width:18px;height:18px;flex:0 0 auto;color:#b9d27a}' +
    '.htn-cart-toast a{display:inline-flex;align-items:center;height:34px;padding:0 16px;border-radius:999px;background:#56652f;color:#fff!important;text-decoration:none!important;font-weight:700}' +
    '.htn-cart-toast a:hover{background:#4a5728}' +
    '@media (max-width:760px){.htn-cart-toast{bottom:86px;font-size:13px}}';
  document.head.appendChild(css);

  /* 1) stop the side cart from opening after an add (header cart icon still opens it) */
  var suppressUntil = 0;
  function wrapOpenPanel() {
    if (typeof window.openPanel !== 'function' || window.openPanel.__htn) return;
    var orig = window.openPanel;
    var wrapped = function (id) {
      if (id === 'cart' && Date.now() < suppressUntil) { suppressUntil = 0; return; }
      return orig.apply(this, arguments);
    };
    wrapped.__htn = 1;
    window.openPanel = wrapped;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[data-panel="cart"], a[href$="/cart"]')) suppressUntil = 0;
  }, true);

  /* helpers */
  function visible(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight; }
  function cartTarget() {
    var list = document.querySelectorAll('#nav-user li.cart > a, #header a[data-panel="cart"], #header a[href$="/cart"], a[data-panel="cart"]');
    for (var i = 0; i < list.length; i++) if (visible(list[i])) return list[i];
    return null;
  }
  function productImage(form, btn) {
    var box = (btn && btn.closest('.htnp')) || form.closest('.htnp');
    if (box) {
      var im = box.querySelector('.htnp__slide.is-active img, .htnp__track img, .htnp__gallery img');
      if (im) return im;
    }
    var scope = form.closest('.htn-card, li, article, .product, [class*="product"]') || form.parentElement;
    for (var n = 0; scope && n < 4; n++, scope = scope.parentElement) {
      var img = scope.querySelector('img');
      if (img && visible(img)) return img;
    }
    return null;
  }

  function fly(img, target, job) {
    if (!img || !target || reduce || !img.animate) { job.flown = true; return; }
    var a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    var size = Math.min(a.width, a.height, 150);
    var sx = a.left + a.width / 2, sy = a.top + a.height / 2;
    var ex = b.left + b.width / 2, ey = b.top + b.height / 2;
    var c = document.createElement('img');
    c.src = img.currentSrc || img.src; c.alt = ''; c.className = 'htn-fly-img';
    c.style.width = size + 'px'; c.style.height = size + 'px';
    c.style.left = (sx - size / 2) + 'px'; c.style.top = (sy - size / 2) + 'px';
    document.body.appendChild(c);
    var dx = ex - sx, dy = ey - sy, lift = Math.min(160, Math.abs(dy) * .35 + 60);
    var anim = c.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * .45 + 'px,' + (dy * .45 - lift) + 'px) scale(.62) rotate(-8deg)', opacity: 1, offset: .5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(8deg)', opacity: .55 }
    ], { duration: 820, easing: 'cubic-bezier(.45,.05,.35,1)', fill: 'forwards' });
    anim.onfinish = function () { c.remove(); job.flown = true; if (job.ok) shake(target); };
  }
  function shake(target) {
    target = target || cartTarget(); if (!target) return;
    target.classList.remove('htn-cart-shake'); void target.offsetWidth; target.classList.add('htn-cart-shake');
    setTimeout(function () { target.classList.remove('htn-cart-shake'); }, 750);
    var badge = target.querySelector('.cart-count') || document.querySelector('#header .cart-count');
    if (badge) { badge.classList.remove('htn-badge-pop'); void badge.offsetWidth; badge.classList.add('htn-badge-pop'); }
  }

  var toastEl, toastT;
  function toast() {
    var url = ((window.routes && routes.cart_url) || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart');
    if (!toastEl) {
      toastEl = document.createElement('div'); toastEl.className = 'htn-cart-toast'; toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg><span></span><a data-panel="cart"></a>';
    toastEl.querySelector('span').textContent = T.added;
    var a = toastEl.querySelector('a'); a.href = url; a.textContent = T.view;
    a.onclick = function (e) {
      if (typeof window.openPanel === 'function' && document.getElementById('cart')) { e.preventDefault(); suppressUntil = 0; window.openPanel('cart'); }
      toastEl.classList.remove('is-on');
    };
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* 2) on "add to cart" submit: fly right away, then shake + toast when the add succeeds */
  var pending = null;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    wrapOpenPanel();
    suppressUntil = Date.now() + 15000;
    var btn = (e.submitter) || f.querySelector('button[type="submit"]');
    var target = cartTarget();
    pending = { t: Date.now(), target: target, flown: false, ok: false };
    fly(productImage(f, btn), target, pending);
  }, true);

  /* watch the theme's add request to know if it worked */
  if (window.fetch && !window.fetch.__htn) {
    var of = window.fetch;
    var nf = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && pending && Date.now() - pending.t < 15000) {
        var job = pending; pending = null;
        p.then(function (res) {
          return res.clone().json().then(function (j) {
            var ok = res.ok && !(j && j.status && j.description);
            if (ok) { job.ok = true; if (job.flown) shake(job.target); toast(); }
            else suppressUntil = 0;
          });
        }).catch(function () { suppressUntil = 0; });
      }
      return p;
    };
    nf.__htn = 1;
    window.fetch = nf;
  }
})();
